var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8AdminSettingsMale50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M24,43l-5-12c0,0-11,1.99-11,13h16.888c-0.263-0.455-0.507-0.921-0.719-1.407L24,43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#303f9f",
    d: "M32.25,35.45c0.32-0.965,0.931-1.797,1.723-2.404C31.409,31.448,29,31,29,31l-4.831,11.593 c0.212,0.485,0.455,0.952,0.719,1.407H30C30,44,32.088,35.937,32.25,35.45z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M24 37L19 31 19 25 29 25 29 31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M35,19c0,1.106-0.896,2-2,2c-1.106,0-2-0.894-2-2c0-1.105,0.894-2,2-2C34.104,17,35,17.895,35,19 M17,19c0-1.105-0.896-2-2-2c-1.106,0-2,0.895-2,2c0,1.106,0.894,2,2,2C16.104,21,17,20.106,17,19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M33,13c0-7.635-18-4.971-18,0v7c0,4.971,4.028,9,9,9c4.971,0,9-4.029,9-9V13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M24,4c-6.075,0-10,4.926-10,11v2.285L16,19v-5l12-4l4,4v5l2-1.742V15c0-4.025-1.038-8.016-6-9l-1-2 H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M27,19c0-0.551,0.448-1,1-1s1,0.449,1,1s-0.448,1-1,1S27,19.551,27,19 M19,19c0,0.551,0.448,1,1,1 s1-0.449,1-1s-0.448-1-1-1S19,18.449,19,19"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 43L19 31 24 32 29 31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M25 35L25.62 39.13 25.13 40.3 24 43 22.38 39.12 23 35 22 34 24 32 26 34z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#607d8b",
    d: "M45.2,38.1c0.1-0.4,0.1-0.8,0.1-1.1s0-0.8-0.1-1.1l2.3-1.7c0.2-0.2,0.3-0.5,0.2-0.7l-2.3-3.9 c-0.1-0.2-0.4-0.3-0.7-0.2l-2.6,1.2c-0.6-0.5-1.3-0.9-2-1.2l-0.3-2.9c0-0.3-0.3-0.5-0.5-0.5h-4.6c-0.2,0-0.5,0.2-0.5,0.5l-0.3,2.9 c-0.7,0.2-1.4,0.6-2,1.1l-2.6-1.2c-0.3-0.1-0.6,0-0.7,0.2l-2.3,4c-0.1,0.2,0,0.5,0.2,0.7l2.3,1.7c-0.1,0.4-0.1,0.8-0.1,1.1 s0,0.8,0.1,1.1l-2.3,1.7c-0.2,0.2-0.3,0.5-0.2,0.7l2.3,3.9c0.1,0.2,0.4,0.3,0.7,0.2l2.6-1.2c0.6,0.5,1.3,0.9,2,1.2l0.3,2.9 c0,0.3,0.3,0.5,0.5,0.5h4.5c0.3,0,0.5-0.2,0.5-0.5l0.3-2.9c0.7-0.3,1.4-0.7,2-1.2l2.6,1.2c0.3,0.1,0.6,0,0.7-0.2l2.3-3.9 c0.1-0.2,0.1-0.6-0.2-0.7L45.2,38.1z M37,42.2c-2.9,0-5.2-2.3-5.2-5.2s2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2S39.9,42.2,37,42.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M37,31c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S40.3,31,37,31 M37,40c-1.7,0-3-1.3-3-3s1.3-3,3-3 s3,1.3,3,3S38.7,40,37,40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AdminSettingsMale50);
export default __webpack_public_path__ + "static/media/icons8-admin-settings-male-50.7640ae020d9fb3ba5ad84cb8de1696ae.svg";
export { ForwardRef as ReactComponent };